export class ResetMultipickingIdentifier
{
    public orderID: number;
}
